module.exports = __webpack_public_path__ + "img/banner_RSV_text_yd.f259ead6.webp";